import { faCheckCircle, faExclamationCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSurveyDataStore } from '../../dataStore'
import { TextEnum } from '../../QuestionTypes/RiwisSlider/mapHelper'
import { useTranslation } from 'react-i18next'

export const Finish = () => {
  const { t } = useTranslation()
  return (
    <div
      style={{ flex: 1 }}
      className="d-flex justify-content-center align-items-center h-100 w-100 align-self-center"
    >
      <p className="h3 text-center">{t('survey.endings.finish')}</p>
    </div>
  )
}

export const RiwisFinish = () => {
  const [{ questionnaire }] = useSurveyDataStore()
  return (
    <div
      style={{ flex: 1 }}
      className="d-flex justify-content-center align-items-center h-100 w-100 align-self-center"
    >
      <p className="h3 text-center">
        Möchten Sie den Umfrage-Teil "{TextEnum[questionnaire.asset_class]}" abschließen?
      </p>
    </div>
  )
}

export const Fail = () => {
  const { t } = useTranslation()

  return (
    <div
      style={{ flex: 1 }}
      className="d-flex justify-content-center align-items-center align-self-center h-100 w-100"
    >
      <div className="d-flex justify-content-center align-items-center flex-wrap"></div>
      <FontAwesomeIcon
        icon={faExclamationCircle}
        className="text-warning align-middle mx-5 mb-4"
        style={{ fontSize: '5rem', float: 'left' }}
      />
      <h3 className="text-center" dangerouslySetInnerHTML={{ __html: t('survey.endings.fail') }} />
    </div>
  )
}

export const Thanks = () => {
  const [{ isSaving, saveMessage }] = useSurveyDataStore()
  const { t } = useTranslation()
  return (
    isSaving === false &&
    (saveMessage.type === 'success' ? (
      <div
        style={{ flex: 1 }}
        className="d-flex justify-content-center align-items-center align-self-center h-100 w-100"
      >
        <div className="d-flex justify-content-center align-items-center flex-wrap">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="text-success align-middle mx-5 mb-4"
            style={{ fontSize: '5rem' }}
          />
          <h3 className="text-center">{t('survey.endings.thanks')}</h3>
        </div>
      </div>
    ) : (
      <Fail />
    ))
  )
}

export const RiwisThanks = () => {
  const [{ nextRiwisQuestionnaire, questionnaire, saveMessage, isSaving }] = useSurveyDataStore()
  return (
    isSaving === false &&
    (saveMessage.type === 'success' ? (
      <div
        style={{ flex: 1 }}
        className="d-flex justify-content-center align-items-center align-self-center h-100 w-100"
      >
        <div className="d-flex justify-content-center align-items-center flex-wrap">
          <FontAwesomeIcon
            icon={faCheckCircle}
            className="text-success align-middle mx-5 mb-4"
            style={{ fontSize: '5rem' }}
          />
          <h3 className="text-center">Vielen Dank für Ihre Teilnahme</h3>
          {nextRiwisQuestionnaire.id !== questionnaire.id && (
            <h5 className="mt-5 text-center">
              Sie können nun mit dem Umfrage-Teil "{TextEnum[nextRiwisQuestionnaire.asset_class]}" fortsetzen
              oder die Umfrage beenden.
            </h5>
          )}
        </div>
      </div>
    ) : (
      <Fail />
    ))
  )
}
